
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dimension-vs-competition",
      function () {
        return require("private-next-pages/dimension-vs-competition/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dimension-vs-competition"])
      });
    }
  